type Translate = (key: string, options?: { defaultValue?: string }) => string

/**
 * Localized copy for a server coupon refusal `reason`. The reason is whatever
 * string the server sent, so an unknown one must never surface as a raw i18n
 * key: it falls back to `fallbackKey`, which each surface picks for itself
 * (the preview field says "can't be used", the submit panel says "no longer
 * valid — re-check the amount").
 *
 * `not_yours` has a signed-out variant: a bound code is only issued to
 * existing accounts, so a visitor without a token who hits it is most likely
 * the owner who has not signed in yet — tell them that, not "wrong account".
 */
export function couponReasonMessage(
  t: Translate,
  reason: string | undefined,
  fallbackKey: string,
  opts?: { signedIn: boolean }
): string {
  if (!reason) return t(fallbackKey)
  if (reason === 'not_yours' && opts && !opts.signedIn) {
    return t('billing.couponReason.not_yours_signed_out', {
      defaultValue: t('billing.couponReason.not_yours'),
    })
  }
  return t(`billing.couponReason.${reason}`, { defaultValue: t(fallbackKey) })
}
